/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvertisementBanner } from '../../models/advertisement-banner';

export interface GetPackagingUnitAdvertisementBanners$Params {
  limit?: number;
  randomize?: boolean;
}

export function getPackagingUnitAdvertisementBanners(http: HttpClient, rootUrl: string, params?: GetPackagingUnitAdvertisementBanners$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdvertisementBanner>>> {
  const rb = new RequestBuilder(rootUrl, getPackagingUnitAdvertisementBanners.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('randomize', params.randomize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdvertisementBanner>>;
    })
  );
}

getPackagingUnitAdvertisementBanners.PATH = '/public/packaging_unit_advertisement_banner_logos';
